import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalSearchApi from 'web-app/react/entities/global-search/api';
import {EntityTypes} from 'web-app/react/entities/global-search/model';

import * as Actions from './actions';

const globalSearchForString = action$ =>
    action$
        .ofType(Actions.search.type, Actions.setCurrentQuery.type)
        .debounceTime(500)
        .mergeMap(({payload}) => {
            const queryString = payload.queryString;

            if (!queryString) {
                return Observable.of(Actions.searchAborted.action());
            }

            if (queryString.length < 5) {
                return Observable.of(Actions.searchAborted.action(i18next.t('messages.tooFewCharactersHint')));
            }

            return GlobalSearchApi.search(
                payload.queryString,
                [EntityTypes.Message, EntityTypes.Conversation],
                payload.institutionIds,
            )
                .map(({searchItems}) => Actions.searchSuccess.action(searchItems))
                .catch(e => Observable.of(Actions.searchFailed.action(e)));
        });

export default combineEpics(globalSearchForString);
